const initialState: Redux.Search = {
	boundingBox: null,
	filterPills: {
		categories: [],
		deiFilters: [],
		limit: 6,
		sidebar: {
			categories: [],
		},
	},
	followableFacets: [],
	followableFilters: [],
	isFetching: false,
	isPermitted: false,
	marketCode: '',
	maxResultColumns: 3,
	pagination: {
		page: 1,
		count: 0,
		limit: 30,
	},
	scoreType: 'IVOL',
	searchCopy: '',
	searchFallback: '',
	sizes: {
		header: 0,
		search: 0,
	},
	sort: 'recommended',
	sortVariation: 'banded-distance',
	sortVersion: '1.0',
	total: 0,
	vendors: [],
	supplemental: [],
	selectedCategories: null,
};

export default initialState;
